import { bindable, bindingMode } from "aurelia-framework";

export class CheckList {
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    selectedList = [];
}